const featuresGroupsReducer = (data = {}, action) => {
    switch(action.type){
        case 'ADD_FEATURES_GROUPS':
            return {
                ...data,
                ...action.data
            }
        case 'EDIT_FEATURES_GROUP':
            return {
                ...data,
                [action.levelId]: action.data
            }
        default:
            return data;
    }
}

export default featuresGroupsReducer;